/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Fine_Print_Balance_CapInputs */

const en_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewards are paid on balances up to $100,000 per user.`)
};

const de_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prämien werden pro Benutzer auf Guthaben bis zu 100.000 $ gezahlt.`)
};

const pt_br2_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As recompensas são pagas sobre saldos de até US$ 100.000 por usuário.`)
};

const tr_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödüller, kullanıcı başına $100.000’a kadar olan bakiyeler üzerinden ödenir.`)
};

const zh_cn2_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每位用户最高可就 100,000 美元的余额获得奖励。`)
};

const zh_hk2_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獎賞按每位用戶最多 $100,000 的結餘計算。`)
};

const ko_kr2_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드는 사용자당 최대 $100,000의 잔액까지 지급됩니다.`)
};

const ru_ru2_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вознаграждения начисляются на баланс до $100 000 на пользователя.`)
};

const es_419_campaigns_mag7_fine_print_balance_cap = /** @type {(inputs: Campaigns_Mag7_Fine_Print_Balance_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las recompensas se pagan sobre saldos de hasta $100,000 por usuario.`)
};

/**
* | output |
* | --- |
* | "Rewards are paid on balances up to $100,000 per user." |
*
* @param {Campaigns_Mag7_Fine_Print_Balance_CapInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_fine_print_balance_cap = /** @type {((inputs?: Campaigns_Mag7_Fine_Print_Balance_CapInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Fine_Print_Balance_CapInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_fine_print_balance_cap(inputs)
	if (locale === "de") return de_campaigns_mag7_fine_print_balance_cap(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_fine_print_balance_cap(inputs)
	if (locale === "tr") return tr_campaigns_mag7_fine_print_balance_cap(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_fine_print_balance_cap(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_fine_print_balance_cap(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_fine_print_balance_cap(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_fine_print_balance_cap(inputs)
	return es_419_campaigns_mag7_fine_print_balance_cap(inputs)
});